module.exports = __webpack_public_path__ + "static/media/custom2.4408c23e.jpg";